module.exports = __webpack_public_path__ + "static/media/img-card-top-back.54207042.png";